import { IntroistDate } from "../../../utils/dates";
import { deleteJson, generateMutation, postJson } from "../ApiBase";

export interface JourneyOverview {
  id: string;
  properties: { [index: string]: string };
  workflowId: string;
  status: string;
  employeeId?: string;
  timezone: string;
  totalCalendarEventCount: number;
  completedCalendarEventCount: number;
  totalMessageCount: number;
  completedMessageCount: number;
  totalScheduledStepCount: number;
  completedScheduledStepCount: number;
  workflowName: string;
  workflowLabel?: string;
  progress?: {
    draft: number;
    scheduled: number;
    delivered: number;
    failing: number;
    completed: number;
    canceled: number;
  };
}

export interface CreateJourneyRequest {
  workflowId: string;
  employeeId: string;
  targetDate?: string;
  draft?: boolean;
}

export interface CreateJourneyResponse {
  id: string;
}

export const createJourney = (req: CreateJourneyRequest): Promise<CreateJourneyResponse> => {
  return postJson("/v2/journeys", req);
};

export interface StartJourneyRequest {
  journeyId: string;
}

export const startJourney = ({ journeyId }: StartJourneyRequest) => {
  return postJson(`/v2/journeys/${journeyId}/start`, {});
};

interface RescheduleJourneyRequest {
  journeyId: string;
  targetDate: IntroistDate;
}

export const rescheduleJourney = (req: RescheduleJourneyRequest) => {
  return postJson(`/v2/journeys/${req.journeyId}/reschedule`, { targetdate: req.targetDate });
};

export interface CancelJourneyRequest {
  journeyId: string;
}

export const cancelJourney = ({ journeyId }: CancelJourneyRequest): Promise<void> => {
  return deleteJson(`/v2/journeys/${journeyId}`);
};

export const useJourneyApi = () => ({
  create: generateMutation<CreateJourneyRequest, CreateJourneyResponse>(createJourney),
  start: generateMutation<StartJourneyRequest, any>(startJourney),
  reschedule: generateMutation<RescheduleJourneyRequest, unknown>(rescheduleJourney),
  cancel: generateMutation<CancelJourneyRequest, any>(cancelJourney)
});
